import { useState } from "react";
import axios from "axios";
import { API_URL } from "../../../../support/api";
import { MediaValidationErrors } from "../../types/media";

type UploadSvgProps = {
	loading: boolean;
	handleFetchList: () => void;
};

export const UploadSvg = ({ loading, handleFetchList }: UploadSvgProps) => {
	const [name, setName] = useState("");
	const [files, setFiles] = useState<FileList | null>(null);
	const [validationErrors, setValidationErrors] =
		useState<MediaValidationErrors>({});

	const handleSubmit = async () => {
		setValidationErrors({});
		if (!files?.length) {
			setValidationErrors({ media: ["Select at least one SVG file."] });
			return;
		}
		try {
			const formData = new FormData();
			formData.append("name", name);
			for (let i = 0; i < files.length; i++) {
				formData.append("svg[]", files[i]);
			}
			const result = await axios.post(
				`${API_URL}/v1/svg-library/store`,
				formData,
				{
					headers: { "Content-Type": "multipart/form-data" },
				}
			);
			if (result.data?.value?.success) {
				setName("");
				setFiles(null);
				handleFetchList();
			}
		} catch (error: unknown) {
			const err = error as { response?: { data?: { errors?: MediaValidationErrors } } };
			if (err?.response?.data?.errors) {
				setValidationErrors(err.response.data.errors);
			}
		}
	};

	return (
		<div
			className={`card card-custom card-flush ${
				loading ? "overlay overlay-block" : ""
			}`}
		>
			<div className="pt-8 card-header">
				<h3 className="card-title">Upload SVG</h3>
			</div>
			<div
				className={`card-body py-5 ${loading ? "overlay-wrapper" : ""}`}
			>
				<div className="grid gap-8 justify-content-start">
					<div className="w-100">
						<div className="media-library-properties">
							<div className="media-library-field mb-3">
								<label className="media-library-label form-label">
									Name
								</label>
								<input
									className="form-control form-control-solid"
									value={name}
									onChange={(e) => setName(e.target.value)}
								/>
								{validationErrors.name?.map((error) => (
									<p
										key={error}
										className="media-library-text-error text-danger small mt-1"
									>
										{error}
									</p>
								))}
							</div>
							<div className="media-library-field mb-3">
								<label className="media-library-label form-label">
									SVG files
								</label>
								<input
									type="file"
									className="form-control form-control-solid"
									accept="image/svg+xml"
									multiple
									onChange={(e) =>
										setFiles(e.target.files || null)
									}
								/>
								{validationErrors.media?.map((error) => (
									<p
										key={error}
										className="media-library-text-error text-danger small mt-1"
									>
										{error}
									</p>
								))}
							</div>
						</div>
					</div>
					<button
						type="button"
						className="mt-5 btn btn-info btn-sm"
						onClick={handleSubmit}
					>
						Submit
					</button>
				</div>
			</div>
		</div>
	);
};
